import { Phone, MessageCircle, Mail } from "lucide-react";
import { scrollTo } from "@/App";

export default function IndustrialFooter() {
    return (
        <footer className="relative bg-tarmac border-t border-ash grain overflow-hidden" data-testid="footer">
            <div className="px-5 sm:px-8 pt-24 pb-10 max-w-7xl mx-auto relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-24">
                    <div>
                        <p className="font-mono text-xs tracking-[0.25em] uppercase text-amber mb-4">[ Contact ]</p>
                        <div className="flex flex-col gap-3">
                            <a data-testid="footer-call-link" href="tel:+447971124650" className="flex items-center gap-3 text-grit hover:text-amber transition-colors duration-200 font-mono text-sm">
                                <Phone size={14} /> 07971 124 650
                            </a>
                            <a data-testid="footer-whatsapp-link" href="https://wa.me/447971124650" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-grit hover:text-amber transition-colors duration-200 font-mono text-sm">
                                <MessageCircle size={14} /> WhatsApp
                            </a>
                            <p data-testid="footer-email-text" className="flex items-center gap-3 text-grit font-mono text-sm">
                                <Mail size={14} /> wedropkerbs@gmail.com
                            </p>
                        </div>
                    </div>
                    <div>
                        <p className="font-mono text-xs tracking-[0.25em] uppercase text-amber mb-4">[ Site ]</p>
                        <div className="flex flex-col gap-3">
                            {[["Process", "#process"], ["Services", "#services"], ["Why us", "#trust"], ["Coverage", "#coverage"], ["FAQ", "#faq"], ["Get a quote", "#quote"]].map(([label, target]) => (
                                <button
                                    key={label}
                                    data-testid={`footer-${label.toLowerCase().replace(/\s/g, "-")}-link`}
                                    onClick={() => scrollTo(target)}
                                    className="text-left text-grit hover:text-amber transition-colors duration-200 font-mono text-sm uppercase tracking-[0.1em]"
                                >
                                    {label}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div>
                        <p className="font-mono text-xs tracking-[0.25em] uppercase text-amber mb-4">[ The promise ]</p>
                        <p className="text-grit text-sm leading-relaxed max-w-xs">
                            One company. One fixed price. Planning, permission, excavation
                            and installation — all handled, all guaranteed.
                        </p>
                    </div>
                </div>

                <div className="road-line w-full mb-10" />

                <h2 className="font-display uppercase leading-[0.85] tracking-tight text-[11vw] lg:text-[9vw] text-paper/95 select-none" data-testid="footer-logo">
                    Drop Kerbs <span className="text-amber">UK</span>
                </h2>

                <div className="flex flex-col sm:flex-row justify-between gap-4 mt-10 pt-6 border-t border-ash">
                    <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-grit">
                        © {new Date().getFullYear()} Drop Kerbs UK — Dropped kerb specialists
                    </p>
                    <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-grit">
                        Fully insured · Council approved
                    </p>
                </div>
            </div>
        </footer>
    );
}
